import createStyle from "@josephmark/createstyle"

/**
 * Display/X Large - 31px
 */
export const H1 = createStyle("h1", "text-[3rem] leading-[1.1] font-normal tracking-[-0.02em]")

/**
 * h2 - 40px
 */
export const H2 = createStyle("h2", "text-[2.5rem] leading-[1.2] tracking-[-0.03em]")

/**
 * Headline/Large - 28px
 */
export const H3 = createStyle("h2", "text-[1.75rem] leading-[1.2] font-normal tracking-[-0.03em]")

/**
 * h4 - 22px
 */
export const H4 = createStyle("h3", "text-[1.375rem] leading-[1.2] tracking-[-0.02em]")

/**
 * h5 - 14px
 */
export const H5 = createStyle("h3", "text-[0.875rem] leading-[1.3] font-normal tracking-[-0.02em]")

/**
 * Headline/Small - 12px
 */
export const H6 = createStyle("h6", "text-[0.75rem] leading-[1.2] font-normal tracking-[-0.02em]")

/**
 * Body/L - 16px
 */
export const P1 = createStyle("p", "text-[1rem] leading-[1.3] tracking-[-0.01em]")

/**
 * Body/Medium - 14px
 */
export const P2 = createStyle("p", "text-[0.875rem] leading-[1.4] tracking-[-0.01em]")

/**
 * Body/Small - 12px
 */
export const P3 = createStyle("p", "text-[0.75rem] leading-[1.3]")

/**
 * Label/Small - 12px
 */
export const LabelSmall = createStyle("p", "text-[0.75rem] leading-[1.2]")

/**
 * Label/X Small - 10px
 */
export const LabelXSmall = createStyle("p", "text-[0.625rem] leading-[1.8]")

/**
 * HelpText - 14px
 */
export const HelpText = createStyle("span", "text-[0.875rem] leading-[1.3]")
